import {Flex, Stack, useTheme} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, {useEffect} from 'react'
import AddToCartCTA from '../../../components/add-to-cart-cta'
import ProductDisplayPrice from '../../../components/product-display-price'
import useBreakpoints from '../../../hooks/use-breakpoints'
import {useZendeskChat} from '../../../components/zendesk-chat'
import {useCommerceData} from '../../../hooks/use-commerce-data'

const PdpCta = ({
    product,
    isPromotionsLoading,
    isVariantLoading,
    promotions,
    quantity,
    ...props
}) => {
    const theme = useTheme()
    const {isEcommerceEnabled, showPricesOnContentOnly} = useCommerceData(product)

    // move Zendesk on mobile view to not overlap with the CTA
    const offset = useBreakpoints(
        // matches the display and height with some margin of the cta
        {base: '5rem', lg: 0}
    )
    const zendeskApi = useZendeskChat()

    useEffect(() => {
        zendeskApi?.setBottomOffset(offset)
    }, [zendeskApi, offset])

    return (
        <Flex
            display={{base: 'flex', lg: 'none'}}
            position="fixed"
            left={0}
            bottom={0}
            width="100%"
            zIndex="sticky"
            align="center"
            height={16.5}
            gap={4}
            background="stokkeCore.white"
            boxShadow={theme.shadows.top}
        >
            {(isEcommerceEnabled || showPricesOnContentOnly) && (
                <Stack spacing={0} paddingLeft={4} minW="0" flex="1">
                    <ProductDisplayPrice
                        product={product}
                        loading={isPromotionsLoading || isVariantLoading}
                        variant="stickyCta"
                    />
                </Stack>
            )}
            <Flex
                paddingLeft={{base: 2, md: 0}}
                paddingRight={2}
                minW="0"
                flex="1"
                justifyContent="center"
                alignItems="center"
                gap={2.5}
            >
                <AddToCartCTA
                    isLoading={isPromotionsLoading || isVariantLoading}
                    product={product}
                    quantity={quantity}
                    variant="solidGreen"
                    {...props}
                />
            </Flex>
        </Flex>
    )
}

PdpCta.propTypes = {
    product: PropTypes.object,
    promotions: PropTypes.array,
    quantity: PropTypes.number,
    isPromotionsLoading: PropTypes.bool,
    isVariantLoading: PropTypes.bool
}

export default PdpCta
